import React, { useState, useEffect } from 'react';
import { Typography, Grid, TextField, Divider, FormHelperText, InputAdornment } from '@mui/material';
import moment from "moment";
import {
    SelectDiscount,
    SelectMonthByQuarter,
    SelectQuarterByAcademicTerms,
    SelectAcademicTermsByAcademicYear,
} from "../../Include/DynamicSelect";
import { useLazyQuery } from "@apollo/client";
import { GET_PRICE_TO_PAY_BY_GRADE } from "../../../Schema/Generalincome";

//date picker
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";


export default function TabsSchool({
    formik,
    gradeId,
    quarterVal,
    discountVal,
    setQuarterVal,
    academicYearId,
    setDiscountVal,
    academicYearVal,
    academicTermVal,
    monthByQuarterVal,
    setAcademicTermVal,
    setMonthByQuarterVal,
}) {

    const {
        errors,
        values,
        touched,
        resetForm,
        handleSubmit,
        getFieldProps,
        setFieldValue,
    } = formik;

    const getPayAs = () => {
        if (monthByQuarterVal?.id) return "Month";
        if (quarterVal?.id) return "Quarter";
        if (academicTermVal?.id) return "Term";
        return "Year";
    }

    const [getPriceToPayByGrade, { data }] = useLazyQuery(GET_PRICE_TO_PAY_BY_GRADE);

    useEffect(() => {
        getPriceToPayByGrade({
            variables: {
                gradeId: gradeId,
                payAs: getPayAs()
            }
        })
    }, [gradeId, getPayAs()]);


    useEffect(() => {
        setFieldValue("academicTermId", academicTermVal?.id);
        if (!academicTermVal?.id) setQuarterVal({ id: "", title: "" });
    }, [academicTermVal]);


    useEffect(() => {
        setFieldValue("quarter", quarterVal?.id);
        if (!quarterVal?.id) setMonthByQuarterVal({ id: "", title: "" });
    }, [quarterVal]);


    useEffect(() => {
        setFieldValue("month", monthByQuarterVal?.date || "");
    }, [monthByQuarterVal]);


    useEffect(() => {
        setFieldValue("discount", discountVal?.id);
    }, [discountVal]);


    useEffect(() => {

        if (monthByQuarterVal?.date) {
            setFieldValue("endDate", moment(monthByQuarterVal?.date).endOf("month"));
            setFieldValue("startDate", moment(monthByQuarterVal?.date).startOf("month"));
            return;
        } else {
            setFieldValue("endDate", quarterVal?.endDate);
            setFieldValue("startDate", quarterVal?.startDate);

        }

        if (quarterVal?.id) {
            setFieldValue("endDate", quarterVal?.endDate);
            setFieldValue("startDate", quarterVal?.startDate);
            return;
        } else {
            setFieldValue("endDate", academicTermVal?.endDate);
            setFieldValue("startDate", academicTermVal?.startDate);

        }

        if (academicTermVal?.id) {
            setFieldValue("endDate", academicTermVal?.endDate);
            setFieldValue("startDate", academicTermVal?.startDate);
            return;
        } else {
            setFieldValue("endDate", academicYearVal?.endDate);
            setFieldValue("startDate", academicYearVal?.startDate);

        }
    }, [monthByQuarterVal, quarterVal, academicTermVal]);


    useEffect(() => {
        if (!academicYearVal?.id) {
            setQuarterVal({ id: "", title: "" });
            setAcademicTermVal({ id: "", title: "" });
            setMonthByQuarterVal({ id: "", title: "" });
        }
    }, [academicYearVal]);

    useEffect(() => {
        setFieldValue("grossAmount", data?.getPriceToPayByGrade);
    }, [data?.getPriceToPayByGrade]);

    useEffect(() => {
        setFieldValue("discountAmount", ((((data?.getPriceToPayByGrade || 0) * (discountVal?.amount || 0)) / 100) + values?.manualDiscount || 0));
    }, [data?.getPriceToPayByGrade, discountVal?.amount, values?.manualDiscount]);

    useEffect(() => {
        setFieldValue("Amount", (data?.getPriceToPayByGrade) - ((((data?.getPriceToPayByGrade || 0) * (discountVal?.amount || 0)) / 100) + values?.manualDiscount || 0) || 0);
        setFieldValue("netAmount", (data?.getPriceToPayByGrade) - ((((data?.getPriceToPayByGrade || 0) * (discountVal?.amount || 0)) / 100) + values?.manualDiscount || 0) || 0);
    }, [data?.getPriceToPayByGrade, discountVal?.amount, values?.manualDiscount]);



    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={6} md={4}>
                <Typography className="field-title">Academic Term</Typography>
                <SelectAcademicTermsByAcademicYear
                    selectedVal={academicTermVal}
                    academicYearId={academicYearId}
                    disabled={!academicYearVal?.id}
                    setSelectedVal={setAcademicTermVal}
                />
                {!!errors.academicTermId && touched.academicTermId && (
                    <FormHelperText error id="outlined-adornment-password">
                        {errors.academicTermId}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Quarter</Typography>
                <SelectQuarterByAcademicTerms
                    selectedVal={quarterVal}
                    setSelectedVal={setQuarterVal}
                    disabled={!academicTermVal?.id}
                    academicTermId={academicTermVal?.id}
                />
                {!!errors.quarter && touched.quarter && (
                    <FormHelperText error id="outlined-adornment-password">
                        {errors.quarter}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Month</Typography>
                <SelectMonthByQuarter
                    quarterVal={quarterVal}
                    disabled={!quarterVal?.id}
                    selectedVal={monthByQuarterVal}
                    setSelectedVal={setMonthByQuarterVal}
                />
                {!!errors.month && touched.month && (
                    <FormHelperText error id="outlined-adornment-password">
                        {errors.month}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Start Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        disabled={true}
                        value={values?.startDate ? values?.startDate : null}
                        inputFormat="dd-MM-yyyy"
                        renderInput={(params) => (
                            <TextField {...params} size="small" fullWidth />
                        )}
                    />
                </LocalizationProvider>
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">End Date</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        disabled={true}
                        value={values?.endDate ? values?.endDate : null}
                        inputFormat="dd-MM-yyyy"
                        renderInput={(params) => (
                            <TextField {...params} size="small" fullWidth />
                        )}
                    />
                </LocalizationProvider>

            </Grid>

            <Grid item xs={12} md={12}>
                <Divider />
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Discount</Typography>
                <SelectDiscount
                    selectedVal={discountVal}
                    setSelectedVal={setDiscountVal}
                />
                {!!errors.discount && touched.discount && (
                    <FormHelperText error id="outlined-adornment-password">
                        {errors.discount}
                    </FormHelperText>
                )}
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Discount Amount</Typography>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    disabled={true}
                    className="text-field"

                    value={values?.discountAmount}

                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                $
                            </InputAdornment>
                        ),
                        inputProps: { min: 0, },
                    }}
                />
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Manual Discount</Typography>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    className="text-field"
                    placeholder='manual discount'
                    {...getFieldProps("manualDiscount")}
                    helperText={touched.manualDiscount && errors.manualDiscount}
                    error={Boolean(touched.manualDiscount && errors.manualDiscount)}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                $
                            </InputAdornment>
                        ),
                        inputProps: { min: 0, },
                    }}
                />
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Sub Total</Typography>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    disabled={true}
                    className="text-field"
                    value={values?.grossAmount}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                $
                            </InputAdornment>
                        ),
                        inputProps: { min: 0, },
                    }}
                />
            </Grid>

            <Grid item xs={6} md={4}>
                <Typography className="field-title">Total</Typography>
                <TextField
                    fullWidth
                    size="small"
                    type="number"
                    disabled={true}
                    className="text-field"
                    value={(data?.getPriceToPayByGrade) - ((((data?.getPriceToPayByGrade || 0) * (discountVal?.amount || 0)) / 100) + values?.manualDiscount || 0) || 0}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                $
                            </InputAdornment>
                        ),
                        inputProps: { min: 0, },
                    }}
                />
            </Grid>

        </Grid>

    );
}